import { Chip } from "@mui/material";

interface Props {
  isPrivate: boolean;
  isProject: boolean;
  size?: "small" | "medium";
  color?: "primary" | "secondary" | "success" | "error" | "info";
}

export function PrivateShipmentChip(props: Props) {
  const { isPrivate, isProject, size = "small", color = "success" } = props;

  if (!isPrivate) {
    return null;
  }

  return (
    <Chip
      label={isProject ? "PRIVATE" : "PRIVATE SHIPMENT"}
      color={color}
      variant="outlined"
      size={size}
    />
  );
}
